import axios from 'axios'
import { getLanguage } from '@/lang'
export function downFile(url) {
	return axios.get(`/common/download?fileName=${url}`, {
		responseType: 'blob',
		headers: {
			'Accept-Language': getLanguage()
		}
	})
}
